import React from "react"
import PropTypes from "prop-types"

import MarkerIcon from "assets/img//ic_location_pin.png"

import GoogleMapReact from "google-map-react"

const Marker = () => (
  <img
    src={MarkerIcon}
    className="img-fluid marker-icon"
    alt="Google Map Marker"
  />
)

export const Map = ({ long, lat, zoom, iframeMapScript, className }) => {
  return (

    <div id="google-maps" className={`${className}`}
        dangerouslySetInnerHTML={{ __html: iframeMapScript }}
    >
    </div>
  )
}

Map.propTypes = {
  long: PropTypes.any,
  lat: PropTypes.any,
  zoom: PropTypes.number,
  iframeMapScript: PropTypes.string,
  className: PropTypes.string,
}

Map.defaultProps = {
  long: 106.82358082434587,
  lat: -6.189836304664987,
  zoom: 16,
  className: "google-maps",
}

// -6.189836304664987, 106.82358082434587